export default "/static/webpack/media/big-five-diagram.en.3c99c5aa.svg";